const chapter = {
  id: 'morphology-flowering-plants',
  slug: 'morphology-flowering-plants',
  subject: 'biology',
  subjectLabel: 'Biology',
  exam: 'NEET',
  title: {
    english: 'Morphology of Flowering Plants',
        hindi: 'पुष्पीय पादपों की आकारिकी',
  },
  estReadMinutes: 60,
  difficulty: {
    english: 'Medium',
        hindi: 'मध्यम',
  },
  weightage: {
    english: '3-4 questions in NEET',
        hindi: 'NEET में 3-4 प्रश्न',
  },
  syllabusTags: ['Structural Organisation', 'NEET', 'Class-11'],
  sections: [
    {
      id: 'root',
      title: {
        english: 'The Root',
        hindi: 'जड़',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Underground part; develops from **radicle** of embryo.',
        hindi: 'भूमिगत भाग; भ्रूण के **रेडिकल** से विकसित होता है।',
            },
            {
              english: 'Types: **Tap root** (dicots — *Mustard*); **Fibrous** (monocots — wheat); **Adventitious** (from any part other than radicle — banyan, monstera, grass).',
        hindi: 'प्रकार: **टैप रूट** (डाइकोट्स - *सरसों*); **रेशेदार** (मोनोकोट - गेहूं); **एडवेंटिवियस** (रेडिकल के अलावा किसी भी भाग से - बरगद, मोन्स्टेरा, घास)।',
            },
            {
              english: 'Regions of root tip (apex → base): **Root cap → Region of meristematic activity → Region of elongation → Region of maturation** (root hairs absorb water + minerals).',
        hindi: 'जड़ की नोक के क्षेत्र (शीर्ष → आधार): ** जड़ टोपी → विभज्योतक गतिविधि का क्षेत्र → बढ़ाव का क्षेत्र → परिपक्वता का क्षेत्र ** (जड़ बाल पानी + खनिजों को अवशोषित करते हैं)।',
            },
            {
              english: 'Modifications:',
        hindi: 'संशोधन:',
            },
            {
              english: '• **Storage** — Tap root: carrot, turnip, beetroot. Adventitious: sweet potato.',
        hindi: '• **भंडारण** — मूसला जड़: गाजर, शलजम, चुकंदर। साहसी: शकरकंद।',
            },
            {
              english: '• **Support** — *Prop roots* (banyan), *Stilt roots* (maize, sugarcane).',
        hindi: '• **समर्थन** — *प्रोप जड़ें* (बरगद), *स्टिल्ट जड़ें* (मक्का, गन्ना)।',
            },
            {
              english: '• **Respiration** — **Pneumatophores** in *Rhizophora* (mangrove).',
        hindi: '• **श्वसन** — **न्यूमेटोफोर्स** *राइजोफोरा* (मैंग्रोव) में।',
            },
            {
              english: '• **Symbiotic** — N₂-fixing nodules (legumes), mycorrhiza.',
        hindi: '• **सहजीवी** - एन₂-फिक्सिंग नोड्यूल्स (फलियां), माइकोराइजा।',
            },
          ],
        },
      ],
    },
    {
      id: 'stem',
      title: {
        english: 'The Stem',
        hindi: 'तना',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Develops from **plumule** of embryo; bears nodes & internodes; positively phototropic.',
        hindi: 'भ्रूण के **प्लम्यूल** से विकसित होता है; भालू नोड्स और इंटरनोड्स; सकारात्मक रूप से फोटोट्रोपिक।',
            },
            {
              english: 'Modifications:',
        hindi: 'संशोधन:',
            },
            {
              english: '• **Underground (storage)** — Rhizome (ginger, turmeric), Tuber (potato — eyes are nodes), Bulb (onion, garlic), Corm (Colocasia).',
        hindi: '• **भूमिगत (भंडारण)** - प्रकंद (अदरक, हल्दी), कंद (आलू - आंखें गांठें हैं), बल्ब (प्याज, लहसुन), कॉर्म (कोलोकेसिया)।',
            },
            {
              english: '• **Sub-aerial (vegetative propagation)** — Runner (grass), Stolon (mint), Sucker (Chrysanthemum), Offset (*Eichhornia*).',
        hindi: '• **उप-हवाई (वानस्पतिक प्रसार)** - रनर (घास), स्टोलन (टकसाल), सकर (गुलदाउदी), ऑफसेट (*इचोर्निया*)।',
            },
            {
              english: '• **Aerial** — **Tendrils** (cucumber, watermelon, grapevine — from axillary bud); **Thorns** (*Citrus, Bougainvillea*); **Phylloclade** (flat, green, photosynthetic — *Opuntia*); **Cladode** (one internode — *Asparagus*).',
        hindi: '• **एरियल** - **टेंड्रिल्स** (ककड़ी, तरबूज, अंगूर - एक्सिलरी कली से); **कांटे** (*साइट्रस, बोगेनविलिया*); **फाइलोक्लेड** (सपाट, हरा, प्रकाश संश्लेषक - *ओपंटिया*); **क्लैडोड** (एक इंटर्नोड - *शतावरी*)।',
            },
          ],
        },
      ],
    },
    {
      id: 'leaf',
      title: {
        english: 'The Leaf',
        hindi: 'पत्ती',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Develops from shoot apical meristem; bears bud in axil.',
        hindi: 'शूट एपिकल मेरिस्टेम से विकसित होता है; भालू कुल्हाड़ी में कली लगाते हैं।',
            },
            {
              english: 'Parts: **leaf base + petiole + lamina**. **Pulvinus** = swollen leaf base (legumes).',
        hindi: 'भाग: **पत्ती का आधार + डंठल + लामिना**। **पुल्विनस** = सूजी हुई पत्ती का आधार (फलियाँ)।',
            },
            {
              english: '**Venation** — Reticulate (dicots) | Parallel (monocots).',
        hindi: '**शिराविन्यास** — रेटिकुलेट (डाइकोट्स) | समानांतर (मोनोकोट्स)। **प्रकार** — सरल (लैमिना पूरी / कटी हुई लेकिन मध्य शिरा तक नहीं पहुंच रही) | यौगिक (मध्यशिरा तक पहुँचने वाला चीरा → पत्रक):',
            },
            {
              english: '**Types** — Simple (lamina entire / incised but not reaching midrib) | Compound (incised reaching midrib → leaflets):',
        hindi: '**प्रकार** - सरल (लैमिना पूरी / कटी हुई लेकिन मध्य शिरा तक नहीं पहुँचना) | यौगिक (मध्यशिरा तक पहुँचने वाला चीरा → पत्रक):',
            },
            {
              english: '• **Pinnately compound** — Neem.',
        hindi: '• **पिननेटली यौगिक** - नीम।',
            },
            {
              english: '• **Palmately compound** — Silk cotton.',
        hindi: '• **पामेटली कंपाउंड** - रेशम कपास।',
            },
            {
              english: 'Phyllotaxy = arrangement of leaves on stem: **Alternate** (China rose, mustard, sunflower); **Opposite** (Calotropis, guava); **Whorled** (*Alstonia*).',
        hindi: 'Phyllotaxy = arrangement of leaves on stem: **Alternate** (China rose, सरसों, सूरजमुखी); **विपरीत** (कैलोट्रोपिस, अमरूद); **व्हर्ल्ड** (*अल्स्टोनिया*)। संशोधन: **टेंड्रिल** (मटर), **स्पाइन** (*ओपंटिया* - वास्तव में एरोल स्पाइन पत्तियां हैं), **भंडारण** (प्याज, लहसुन), **फिलोड** (ऑस्ट्रेलियाई बबूल), **कीट-फँसाने** (पिचर प्लांट *नेपेंथेस*, वीनस फ्लाईट्रैप)।',
            },
            {
              english: 'Modifications: **Tendril** (pea), **Spine** (*Opuntia* — actually areole spines are leaves), **Storage** (onion, garlic), **Phyllode** (Australian acacia), **Insect-trapping** (pitcher plant *Nepenthes*, Venus flytrap).',
        hindi: 'संशोधन: **टेंड्रिल** (मटर), **स्पाइन** (*ओपंटिया* - वास्तव में एरिओल स्पाइन पत्तियां हैं), **भंडारण** (प्याज, लहसुन), **फिलोड** (ऑस्ट्रेलियाई बबूल), **कीट-फँसाने** (पिचर प्लांट *नेपेंथेस*, वीनस फ्लाईट्रैप)।',
            },
          ],
        },
      ],
    },
    {
      id: 'inflorescence-flower',
      title: {
        english: 'Inflorescence & Flower',
        hindi: 'पुष्पक्रम और पुष्प',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Inflorescence = arrangement of flowers on floral axis. Two types:',
        hindi: 'पुष्पक्रम = पुष्प अक्ष पर फूलों की व्यवस्था। दो प्रकार:',
            },
            {
              english: '• **Racemose** — main axis grows continuously; flowers borne laterally in **acropetal** order (mustard).',
        hindi: '• **रेसमोस** — मुख्य अक्ष लगातार बढ़ता है; **एक्रोपेटल** क्रम (सरसों) में पार्श्व रूप से लगे फूल।',
            },
            {
              english: '• **Cymose** — main axis terminates in flower; flowers in **basipetal** order (*Solanum*).',
        hindi: '• **साइमोज़** — मुख्य अक्ष फूल में समाप्त होता है; फूल **बेसिपेटल** क्रम में (*सोलनम*)।',
            },
            {
              english: 'Flower = modified shoot for sexual reproduction. 4 whorls on **thalamus**: **Calyx (sepals) → Corolla (petals) → Androecium (stamens) → Gynoecium (carpels)**.',
        hindi: 'Flower = modified shoot for sexual reproduction। **थैलेमस** पर 4 चक्र: **कैलिक्स (बाह्यदल) → कोरोला (पंखुड़ियाँ) → एंड्रोइकियम (पुंकेसर) → गाइनोइकियम (कार्पेल)**।',
            },
            {
              english: 'Symmetry — Actinomorphic (radial — mustard, Datura, chilli) | Zygomorphic (bilateral — pea, gulmohur, *Cassia*) | Asymmetric (Canna).',
        hindi: 'समरूपता - एक्टिनोमोर्फिक (रेडियल - सरसों, धतूरा, मिर्च) | ज़िगोमोर्फिक (द्विपक्षीय - मटर, गुलमोहर, *कैसिया*) | असममित (कैना)।',
            },
            {
              english: 'Position of ovary:',
        hindi: 'अंडाशय की स्थिति:',
            },
            {
              english: '• **Hypogynous** — superior ovary, others below (mustard, China rose, brinjal).',
        hindi: '• **हाइपोगिनस** - ऊपरी अंडाशय, अन्य नीचे (सरसों, चीनी गुलाब, बैंगन)।',
            },
            {
              english: '• **Perigynous** — ovary half-inferior; others at same level (plum, rose, peach).',
        hindi: '• **पेरिगिनस** - अंडाशय आधा-निचला; अन्य समान स्तर पर (बेर, गुलाब, आड़ू)।',
            },
            {
              english: '• **Epigynous** — inferior ovary; others above (guava, cucumber, sunflower ray florets).',
        hindi: '• **एपिगिनस** - अवर अंडाशय; उपरोक्त अन्य (अमरूद, ककड़ी, सूरजमुखी किरण पुष्प)। **कैलिक्स** — बाह्यदल; गैमोसेपलस (संयुक्त) या पॉलीसेपलस (मुक्त)।',
            },
          ],
        },
      ],
    },
    {
      id: 'parts-flower',
      title: {
        english: 'Parts of a Flower (Whorls)',
        hindi: 'पुष्प के भाग (चक्र)',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Calyx** — sepals; gamosepalous (united) or polysepalous (free).',
        hindi: '**कैलिक्स** - बाह्यदल; गैमोसेपलस (संयुक्त) या पॉलीसेपलस (मुक्त)।',
            },
            {
              english: '**Corolla** — petals; aestivation: Valvate, Twisted (China rose, *Cotton*), Imbricate (*Cassia*, gulmohur), **Vexillary/Papilionaceous** (pea, bean — 5 petals: 1 standard + 2 wings + 2 keel).',
        hindi: '**कोरोला** - पंखुड़ियाँ; सौंदर्यीकरण: वाल्वेट, ट्विस्टेड (चीनी गुलाब, *कपास*), इम्ब्रिकेट (*कैसिया*, गुलमोहर), **Vexillary/Papilionaceous** (मटर, बीन - 5 पंखुड़ियाँ: 1 मानक + 2 पंख + 2 कील)।',
            },
            {
              english: '**Androecium** — stamens (filament + anther — usually 2-lobed, 4 microsporangia). Conditions: **Epipetalous** (attached to petals — brinjal); **Epiphyllous** (attached to perianth — lily); **Polyandrous / Monadelphous (China rose) / Diadelphous (pea) / Polyadelphous (citrus)**.',
        hindi: '**एंड्रोइकियम** - पुंकेसर (फिलामेंट + एथर - आमतौर पर 2-लोबेड, 4 माइक्रोस्पोरंगिया)। शर्तें: **एपिपेटलस** (पंखुड़ियों से जुड़ा हुआ - बैंगन); **एपिफ़िलस** (पेरियनथ से जुड़ा हुआ - लिली); **पॉलीएंड्रस / मोनडेल्फ़स (चीनी गुलाब) / डायडेल्फ़स (मटर) / पॉलीएडेल्फ़स (साइट्रस)**।',
            },
            {
              english: '**Gynoecium** — pistil(s); each pistil = stigma + style + ovary. Apocarpous (free — lotus, rose) | Syncarpous (united — mustard, tomato).',
        hindi: '**गाइनोइकियम** - स्त्रीकेसर; प्रत्येक pistil = stigma + style + ovary। एपोकार्पस (मुक्त - कमल, गुलाब) | सिंकार्पस (संयुक्त - सरसों, टमाटर)।',
            },
            {
              english: '**Placentation** — arrangement of ovules in ovary: **Marginal** (pea) | **Axile** (China rose, tomato, lemon) | **Parietal** (mustard, *Argemone*) | **Free central** (*Dianthus, Primrose*) | **Basal** (sunflower, marigold).',
        hindi: '**प्लेसेन्टेशन** — अंडाशय में बीजांड की व्यवस्था: **सीमांत** (मटर) | **एक्साइल** (चीनी गुलाब, टमाटर, नींबू) | **पार्श्विका** (सरसों, *आर्गेमोन*) | **फ्री सेंट्रल** (*डायन्थस, प्रिमरोज़*) | **बेसल** (सूरजमुखी, गेंदा)।',
            },
          ],
        },
      ],
    },
    {
      id: 'fruit-seed',
      title: {
        english: 'Fruit, Seed & Floral Formula',
        hindi: 'फल, बीज और पुष्प सूत्र',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Fruit** = mature ovary after fertilisation; **parthenocarpic fruit** = without fertilisation (banana).',
        hindi: '**फल** = निषेचन के बाद परिपक्व अंडाशय; **पार्थेनोकार्पिक फल** = बिना निषेचन के (केला)।',
            },
            {
              english: 'True fruit (only ovary develops — mango, coconut) vs **False fruit** (thalamus also part — apple, strawberry, cashew).',
        hindi: 'सच्चा फल (केवल अंडाशय विकसित होता है - आम, नारियल) बनाम **झूठा फल** (थैलेमस भी भाग - सेब, स्ट्रॉबेरी, काजू)।',
            },
            {
              english: 'Pericarp 3 layers — **epicarp + mesocarp + endocarp**.',
        hindi: 'पेरिकार्प 3 परतें - **एपिकार्प + मेसोकार्प + एंडोकार्प**।',
            },
            {
              english: 'Drupe (mango — endocarp stony; coconut — fibrous mesocarp).',
        hindi: 'ड्रूप (आम - एंडोकार्प स्टोनी; नारियल - रेशेदार मेसोकार्प)।',
            },
            {
              english: '**Seed** — outer **testa** + inner **tegmen**; embryo with radicle + plumule + cotyledon(s); endosperm in albuminous seed (castor, coconut) or absent in non-albuminous (pea, groundnut, bean).',
        hindi: '**बीज** — बाहरी **टेस्टा** + भीतरी **टेगमेन**; रेडिकल + प्लम्यूल + बीजपत्र के साथ भ्रूण; एल्ब्यूमिनस बीज (अरंडी, नारियल) में भ्रूणपोष या गैर-एलब्यूमिनस (मटर, मूंगफली, सेम) में भ्रूणपोष अनुपस्थित।',
            },
            {
              english: '**Floral formula** symbols: ⊕ actinomorphic, % zygomorphic, ☿ bisexual, ♂ male, ♀ female; K = calyx, C = corolla, P = perianth, A = androecium, G = gynoecium; () = fused; bar above = epigynous, bar below = hypogynous.',
        hindi: '**पुष्प सूत्र** प्रतीक: ⊕ एक्टिनोमोर्फिक, % जाइगोमोर्फिक, ☿ उभयलिंगी, ♂ पुरुष, ♀ महिला; के = कैलेक्स, सी = कोरोला, पी = पेरिंथ, ए = एंड्रोइकियम, जी = गाइनोइकियम; () = जुड़े हुए; ऊपर पट्टी = अधिजठर, नीचे पट्टी = अधोलिंगी।',
            },
            {
              english: 'Examples — **Fabaceae (pea family)**: ⊕ ☿ K(5) C 1+2+(2) A(9)+1 G̲1; **Solanaceae**: ⊕ ☿ K(5) C(5) A5 G̲(2); **Liliaceae**: ⊕ ☿ P(3+3) A(3+3) G̲(3).',
        hindi: 'उदाहरण - **फैबेसी (मटर परिवार)**: ⊕ ☿ K(5) C 1+2+(2) A(9)+1 G̲1; **सोलानेसी**: ⊕ ☿ K(5) C(5) A5 G̲(2); **लिलियासी**: ⊕ ☿ P(3+3) A(3+3) G̲(3)।',
            },
          ],
        },
      ],
    },
  ],
  keyFormulas: [
    {
      latex: '\\text{Tap (dicot) | Fibrous (monocot) | Adventitious roots}',
      desc: {
        english: '',
        hindi: 'टैप करें (डाइकोट) | रेशेदार (मोनोकोट) | साहसिक जड़ें',
      },
    },
    {
      latex: '\\text{Pneumatophore = respiratory root (Rhizophora)}',
      desc: {
        english: '',
        hindi: 'न्यूमेटोफोर = श्वसन जड़ (राइजोफोरा)',
      },
    },
    {
      latex: '\\text{Tuber = stem; eyes = nodes (potato); turmeric = rhizome}',
      desc: {
        english: '',
        hindi: 'कंद = तना; आंखें = नोड्स (आलू); हल्दी = प्रकंद',
      },
    },
    {
      latex: '\\text{Aestivation: Valvate, Twisted, Imbricate, Vexillary}',
      desc: {
        english: '',
        hindi: 'सौंदर्यीकरण: वाल्वेट, ट्विस्टेड, इम्ब्रिकेट, वेक्सिलरी',
      },
    },
    {
      latex: '\\text{Placentation: Marginal, Axile, Parietal, Free central, Basal}',
      desc: {
        english: '',
        hindi: 'प्लेसेंटेशन: सीमांत, धुरी, पार्श्विका, मुक्त केंद्रीय, बेसल',
      },
    },
    {
      latex: '\\text{Hypogynous (superior) | Perigynous | Epigynous (inferior)}',
      desc: {
        english: '',
        hindi: 'हाइपोगिनस (श्रेष्ठ) | पेरिगिनस | एपिगिनस (अवर)',
      },
    },
    {
      latex: '\\text{Fabaceae: K(5) C 1+2+(2) A(9)+1 G}_1',
      desc: {
        english: '',
        hindi: 'फैबेसी: के(5) सी 1+2+(2) ए(9)+1 जी 1',
      },
    },
  ],
  pyqs: [
    {
      year: 2024,
      exam: 'NEET',
      tag: 'Modification',
      problem: {
        english: 'Pneumatophores are seen in:',
        hindi: 'न्यूमेटोफोरस इनमें देखे जाते हैं:',
      },
      answer: {
        english: 'Mangroves (Rhizophora)',
        hindi: 'मैंग्रोव (राइजोफोरा)',
      },
      solution: {
        english: 'Negatively geotropic respiratory roots.',
        hindi: 'नकारात्मक रूप से भू-उष्णकटिबंधीय श्वसन जड़ें।',
      },
    },
    {
      year: 2023,
      exam: 'NEET',
      tag: 'Aestivation',
      problem: {
        english: 'Aestivation in pea flower is:',
        hindi: 'मटर के फूल में सौंदर्यीकरण है:',
      },
      answer: {
        english: 'Vexillary (Papilionaceous)',
        hindi: 'वेक्सिलरी (पैपिलिओनेसियस)',
      },
      solution: {
        english: '1 standard + 2 wings + 2 keel petals.',
        hindi: '1 मानक + 2 पंख + 2 उलट पंखुड़ियाँ।',
      },
    },
    {
      year: 2022,
      exam: 'NEET',
      tag: 'Placentation',
      problem: {
        english: 'Placentation in mustard is:',
        hindi: 'सरसों में रोपण है:',
      },
      answer: {
        english: 'Parietal',
        hindi: 'पार्श्विका',
      },
      solution: {
        english: 'Ovules on inner walls of ovary.',
        hindi: 'अंडाशय की भीतरी दीवारों पर अंडाणु।',
      },
    },
    {
      year: 2020,
      exam: 'NEET',
      tag: 'False fruit',
      problem: {
        english: 'Apple is a false fruit because:',
        hindi: 'सेब एक झूठा फल है क्योंकि:',
      },
      answer: {
        english: 'Thalamus contributes to fleshy part',
        hindi: 'थैलेमस मांसल भाग में योगदान देता है',
      },
      solution: {
        english: 'Pomes; only seed core is from ovary.',
        hindi: 'पोम्स; केवल बीज कोर अंडाशय से है।',
      },
    },
    {
      year: 2019,
      exam: 'NEET',
      tag: 'Inflorescence',
      problem: {
        english: 'Acropetal arrangement of flowers is found in:',
        hindi: 'फूलों की एक्रोपेटल व्यवस्था पाई जाती है:',
      },
      answer: {
        english: 'Racemose inflorescence',
        hindi: 'रेसमोस पुष्पक्रम',
      },
      solution: {
        english: 'Older flowers at base, younger at apex.',
        hindi: 'आधार पर पुराने फूल, शीर्ष पर छोटे फूल।',
      },
    },
  ],
  next: {
    slug: 'anatomy-flowering-plants',
    title: 'Anatomy of Flowering Plants',
  },
};

export default chapter;
